import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";

export const ModalVideo = ({ showVideo, setShowVideo, title, videoFile }) => {
  const handleClose = () => setShowVideo(false);

  return (
    <Modal
      show={showVideo}
      onHide={handleClose}
      centered
      animation
      dialogClassName="text-light"
    >
      {/* <Modal.Header
        closeButton
        closeVariant="white"
        className="border border-info border-3 border-bottom-0 rounded-top"
        style={{ backgroundColor: "rgb(0, 43, 110)" }}
      > */}
      {/* <Modal.Title className="text-center w-100">{title}</Modal.Title> */}
      {/* </Modal.Header> */}
      <Modal.Body
        className="px-0 fw-light w-100"
        style={{ backgroundColor: "rgb(0, 43, 110)" }}
      >
        <ReactPlayer
          url={videoFile}
          width="100%"
          height="auto"
          playing={true}
          loop={true}
        />
      </Modal.Body>
      {/* <Modal.Footer
        className="border border-info border-3 border-top-0"
        style={{ backgroundColor: "rgb(0, 43, 110)" }}
      ></Modal.Footer> */}
    </Modal>
  );
};

export default ModalVideo;
